import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import server from "./plugins/server";
import alert from "./plugins/alert";
import vuetify from './plugins/vuetify'

import Session from "./mixins/session";
import Dates from "./mixins/dates";
import Clipboard from "./mixins/clipboard";

Vue.config.productionTip = false
Vue.use(server, {
  baseUrl: process.env.VUE_APP_SERVER_BASE_URL || "",
  fullUrl: process.env.VUE_APP_SERVER_BASE_FULL_URL || ""
});
Vue.use(alert);

Vue.mixin(Session);
Vue.mixin(Dates);
Vue.mixin(Clipboard);

fetch("/app-config")
  .then(r => r.json())
  .catch(() => ({ appOwner: "Omniaevo SRL", appOwnerLogo: undefined }))
  .then(({ appOwner, appOwnerLogo }) => {
    document.title = `${document.title} | ${appOwner}`;

    if (appOwnerLogo) {
      const favicon = document.querySelector("link[rel~='icon']");
      if (favicon) favicon.href = appOwnerLogo;
    }

    Vue.mixin({
      data: () => ({ appOwner, appOwnerLogo })
    });

    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app');
  });
